import * as tslib_1 from "tslib";
import * as React from 'react';
import { avatar } from 'src/models/User';
import { Avatar, ListItem, Divider } from 'material-ui';
import Badge from 'src/components/Badge';
import { red500 } from 'material-ui/styles/colors';
import { observer } from 'mobx-react';
var MessageGroup = /** @class */ (function (_super) {
    tslib_1.__extends(MessageGroup, _super);
    function MessageGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.update = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    MessageGroup.prototype.componentWillMount = function () {
        this.props.store.messages.refresh.subscribe(this.update);
    };
    MessageGroup.prototype.componentWillUnmount = function () {
        this.props.store.messages.refresh.unsubscribe(this.update);
    };
    MessageGroup.prototype.render = function () {
        var _a = this.props, user = _a.user, store = _a.store, onSelect = _a.onSelect;
        var unreaded = store.messages.unreadedMessagesByUser(user.id);
        var badge = unreaded === 0
            ? null
            : React.createElement(Badge, { color: red500, children: unreaded, styleOverride: { float: 'right' } });
        return (React.createElement(React.Fragment, null,
            React.createElement(ListItem, { style: { fontSize: '12px' }, primaryText: user.name, secondaryText: React.createElement("small", null, store.messages.lastActivity(user.id)), leftAvatar: React.createElement(Avatar, { src: avatar(user.id) }), rightAvatar: badge, onClick: function (e) {
                    e.preventDefault();
                    onSelect(user.id);
                } }),
            React.createElement(Divider, null)));
    };
    MessageGroup = tslib_1.__decorate([
        observer
    ], MessageGroup);
    return MessageGroup;
}(React.Component));
export default MessageGroup;



//////////////////
// WEBPACK FOOTER
// ./src/pages/messages/MessageGroup.tsx
// module id = 802
// module chunks = 0